import * as React from 'react';
import * as ReqType from '../../types/ServerRequests';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { FormAdhere1 } from '../MembershipPage/internalComponents/Adhere1';
import { FormAdhere2 } from '../MembershipPage/internalComponents/Adhere2';
import { FormAdhere3 } from '../MembershipPage/internalComponents/Adhere3';
import { LoaderButton } from '../genericComponents/Button/LoaderButton';
import { SubscriptionsService } from '../../services/SubscriptionService';
import { DocumentsProfile } from '../ProfilePage/internalComponents/DocumentsProfile';
import '../genericComponents/Button/LoaderButton.css';

interface Props {
    match: {
        path: string,
        url: string,
        isExact: boolean,
        params: {
            user_id: string
        }
    };
}

interface State {
    disabled1: boolean;
    disabled2: boolean;
    disabled3: boolean;
}

/**
 * Ce composant permet d'afficher la page d'inscription d'un utilisateur depuis un compte admin
 */
export class ShowSubscriptionPage extends React.Component {
    props: Props;
    state: State;
    private form1?: FormAdhere1;
    private form2?: FormAdhere2;
    private form3?: FormAdhere3;

    constructor(props: Props) {
        super(props);
        this.state = {
            disabled1: true,
            disabled2: true,
            disabled3: true
        };
        this.form1 = undefined;
        this.form2 = undefined;
        this.form3 = undefined;
    }

    switchEditable1 = () => {
        this.setState({ disabled1: !this.state.disabled1 });
    }
    switchEditable2 = () => {
        this.setState({ disabled2: !this.state.disabled2 });
    }
    switchEditable3 = () => {
        this.setState({ disabled3: !this.state.disabled3 });
    }

    submit1 = () => {
        if (this.form1 !== undefined) {
            var datas = this.form1.getData();
            if (datas.nom === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer un nom');
                    }
                );
            } else if (datas.prenom === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer un prenom');
                    }
                );
            } else if (datas.date_naissance === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer une date de naissance');
                    }
                );
            } else if (datas.adresse.numero === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer le numéro de la rue');
                    }
                );
            } else if (datas.adresse.rue === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer un nom de rue');
                    }
                );
            } else if (datas.adresse.complement === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer un complement');
                    }
                );
            } else if (datas.adresse.ville === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer une ville');
                    }
                );
            } else if (datas.adresse.code_postal === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer un code postal');
                    }
                );
            } else if (datas.telephone === '') {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer un numéro de téléphone');
                    }
                );
            } else {
                return (
                    SubscriptionsService.getInstance()
                        .createSubscribePart1(datas, Number.parseInt(this.props.match.params.user_id))
                        .then(
                            () => {
                                this.switchEditable1();
                            }
                        )
                );
            }
        } else {
            return Promise.reject('');
        }
    }

    submit2 = () => {
        if (this.form2 !== undefined) {
            var datas = this.form2.getForm();
            if (datas.cours.length === 0) {
                return Promise.resolve().then(
                    () => {
                        alert('Veuillez choisir un cours.');
                    }
                );
            } else if (datas.mode_reglement === ReqType.ModeReglement.UNDEFINED) {
                return Promise.resolve().then(
                    () => {
                        alert('Veuillez choisir un mode de payement.');
                    }
                );
            } else if (datas.mode_reglement === ReqType.ModeReglement.CHEQUE && 
                datas.nombre_cheque === null
            ) {
                return Promise.resolve().then(
                    () => {
                        alert('Entrer le nombre de cheques');
                    }
                );
            } else {
                return (
                    SubscriptionsService.getInstance()
                        .createSubscribePart2(
                            datas,
                            Number.parseInt(this.props.match.params.user_id)
                        )
                        .then(
                            () => {
                                this.switchEditable2();
                            }
                        )
                );
            }
        } else {
            return Promise.reject('');
        }
    }

    submit3 = () => {
        if (this.form3 !== undefined) {
            var datas = this.form3.getForm();
            if (datas === null) {
                return Promise.reject('');
            } else {
                return (
                    SubscriptionsService.getInstance()
                        .createSubscribePart3(datas, Number.parseInt(this.props.match.params.user_id))
                        .then(
                            () => {
                                this.switchEditable3();
                            }
                        )
                );
            }
        } else {
            return Promise.reject('');
        }
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                ]}
            >
                <div style={{paddingTop: '1cm', paddingBottom: '1cm'}}>
                    <div className="card card-default" style={{marginBottom: '2cm'}}>
                        <div className="card-header col-12">
                            <h4 className="text-white">
                                <strong>Informations générales</strong>
                            </h4>
                        </div>
                        <div className="card-body" style={{paddingLeft: '10px'}}>
                            <FormAdhere1
                                register={this.registerForm1}
                                disabled={this.state.disabled1}
                                hidden={true}
                                user_id={Number.parseInt(this.props.match.params.user_id)}
                            />
                        </div>
                        <div className="card-footer">
                            <button
                                onClick={this.switchEditable1}
                                className="btn"
                                style={!this.state.disabled1 ? { display: 'none' } :
                                    {marginLeft: '1cm', width: '3cm'}}
                            >
                                Modifier
                            </button>
                            <div className="row">
                                <button
                                    onClick={this.switchEditable1}
                                    style={this.state.disabled1 ? { display: 'none' } :
                                        {marginLeft: '1cm', width: '3cm'}}
                                    className="btn btn-outline-danger"
                                >
                                    Annuler
                                </button>
                                <LoaderButton
                                    onClick={this.submit1}
                                    style={this.state.disabled1 ? { display: 'none' } :
                                        {marginLeft: '20px', width: '3cm'}}
                                    className="btn"
                                >
                                    Valider
                                </LoaderButton>
                            </div>
                        </div>

                    </div>

                    <div className="card card-default" style={{marginBottom: '2cm'}}>
                        <div className="card-header col-12">
                            <h4 className="text-white">
                                <strong>Cours et mode de réglement</strong>
                            </h4>
                        </div>
                        <div  className="card-body" style={{paddingLeft: '10px'}}>
                            <FormAdhere2
                                register={this.registerForm2}
                                disabled={this.state.disabled2}
                                hidden={true}
                                user_id={Number.parseInt(this.props.match.params.user_id)}
                            />
                        </div>
                        <div className="card-footer">
                            <button
                                onClick={this.switchEditable2}
                                className="btn"
                                style={!this.state.disabled2 ? { display: 'none' } : {marginLeft: '1cm', width: '3cm'}}
                            >
                                Modifier
                            </button>
                            <div className="row">
                                <button
                                    onClick={this.switchEditable2}
                                    className="btn btn-outline-danger"
                                    style={this.state.disabled2 ? { display: 'none' } :
                                        {marginLeft: '1cm', width: '3cm'}}
                                >
                                    Annuler
                                </button>
                                <LoaderButton
                                    onClick={this.submit2}
                                    style={this.state.disabled2 ? { display: 'none' } :
                                        {marginLeft: '20px', width: '3cm'}}
                                    className="btn"
                                >
                                    Valider
                                </LoaderButton>
                            </div>
                        </div>
                    </div>

                    <div className="card card-default" style={{marginBottom: '2cm'}}>
                        <div className="card-header col-12">
                            <h4 className="text-white">
                                <strong>Pièces à fournir</strong>
                            </h4>
                        </div>
                        <div className="card-body" style={{paddingLeft: '10px'}}>
                            <FormAdhere3
                                register={this.registerForm3}
                                disabled={this.state.disabled3}
                                hidden={true}
                                user_id={Number.parseInt(this.props.match.params.user_id)}
                            />
                        </div>
                        <div className="card-footer">
                            <button
                                onClick={this.switchEditable3}
                                className="btn"
                                style={!this.state.disabled3 ? { display: 'none' } : {marginLeft: '1cm', width: '3cm'}}
                            >
                                Modifier
                            </button>
                            <div className="row">
                                <button
                                    onClick={this.switchEditable3}
                                    className="btn btn-outline-danger"
                                    style={this.state.disabled3 ? { display: 'none' } :
                                        {marginLeft: '1cm', width: '3cm'}}
                                >
                                    Annuler
                                </button>
                                <LoaderButton
                                    onClick={this.submit3}
                                    style={this.state.disabled3 ? { display: 'none' } :
                                        {marginLeft: '20px', width: '3cm'}}
                                    className="btn"
                                >
                                    Valider
                                </LoaderButton>
                            </div>
                        </div>
                    </div>

                    <div>
                        <DocumentsProfile user_id={this.props.match.params.user_id} hidden={true}/>
                    </div>
                </div>
            </PageChorinitia>
        );
    }

    private registerForm1 = (form: FormAdhere1) => {
        this.form1 = form;
    }
    private registerForm2 = (form: FormAdhere2) => {
        this.form2 = form;
    }
    private registerForm3 = (form: FormAdhere3) => {
        this.form3 = form;
    }
}


// WEBPACK FOOTER //
// ./src/components/ShowSubscriptionPage/ShowSubscriptionPage.tsx